<keycloak-auth-manager-kam-group-selection
    [initialGroupsSelected]="initialGroupsSelected"
    (groupSelection)="groupSelectionUpdate($event)"> 
</keycloak-auth-manager-kam-group-selection>
<div style="text-align: center" >
    <button mat-button matStepperPrevious>{{"KAM-GENERAL-DIALOG.BACK" |translate}}</button>
    <button mat-button matStepperNext (click)="step3End()">{{"KAM-GENERAL-DIALOG.NEXT" |translate}}</button>
</div>